<template>
    <div class="d-flex flex-column align-items-center">
    <content-header-custom
      title="Registrations"
      class="w-100 mxw-md px-10"
      :subTitle="subTitle"
    />
    <content-body-card class="w-100">
      <el-row class="mb-20">
        <el-col :span="24">
            <el-tabs v-model="activeTab">
              <el-tab-pane label="Registrations" name="registrations" :lazy="true">
                  <div class="mb-10">
                    <el-select v-model="selectedMember" @change="handleMemberChange">
                      <el-option v-for="member in memberList" :key="member._id"  :label="`${member.profile.firstName} ${member.profile.lastName}`" :value="member._id">
                        {{ member.profile.firstName }} {{ member.profile.lastName }}
                      </el-option>
                    </el-select>
                  </div>
                  <Registrations :key="selectedMember" v-model="member" />
                </el-tab-pane >
                <el-tab-pane label="Teams" name="teams" :lazy="true">
                  <Teams />
                </el-tab-pane>
                <el-tab-pane label="Bulk Registrations" name="bulkRegistration" :lazy="true">
                  <BulkRegistration />
                </el-tab-pane>
              </el-tabs>
        </el-col>
      </el-row>
    </content-body-card>

  </div>
  </template>

<script>
import Teams from './Teams.vue';
import BulkRegistration from './BulkRegistrations.vue';
import Registrations from './components/RegoHistory.vue';

export default {
  components: {
    Teams,
    BulkRegistration,
    Registrations
  },
  data() {
    return {
      activeTab: 'registrations',
      // write a longer description
      subTitle: 'View and manage your registrations',
      memberList: [],
      memberId: null,
      selectedMember: null,
      member: undefined
    };
  },
  async mounted() {
    await this.getMemberList();
  },
  methods: {
    async getMemberList() {
      const response = await this.$http.get('/assemble/api/v1/account/portal/members');
      this.memberList = response.data.data;
      if (!this.memberId) {
        const activeMember = this.$store.getters['user/activeMember'];
        if (activeMember && activeMember._id) {
          this.memberId = activeMember._id;
          this.selectedMember = activeMember._id;
          this.member = activeMember;
        }
        // this.memberId = activeMember._id;
      }
    },
    handleMemberChange(memberId) {
      this.selectedMember = memberId;
      this.member = this.memberList.find((member) => member._id === memberId);
    }
  }
};
</script>

  <style scoped>
  /* Add your styles here */
  </style>
